/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-04-11 09:11:40
 * @LastEditTime : 2025-10-29 08:54:01
 * @LastEditors  : yangxr
 * @Description  : 生产运输API
 * @FilePath     : \icps_fb\src\api\smart\productTransport_outside.js
 */
import request from "@/utils/request";
//获取站上人员列表
export function queryUserByOrganization(data) {
  return request({
    url: "/base/system/user/queryUserByOrganization",
    method: "post",
    data,
  });
}
//保存人员信息
export function savePeople(data) {
  return request({
    url: "/icps/system/sign/intelligent/proLogTask/savePeople",
    method: "post",
    data,
  });
}
//获取人员信息
export function queryPeople(data) {
  return request({
    url: "/icps/system/sign/intelligent/proLogTask/queryPeople",
    method: "post",
    data,
  });
}
//获取生产线
export function queryLineByStation(data) {
  return request({
    url: "/icps/system/sign/basics/station/queryLineByStation",
    method: "post",
    data,
  });
}

//获取订单列表
export function queryPlanList(data) {
  return request({
    url: "/icps/system/sign/intelligent/planTransport/queryPlanList",
    method: "post",
    data,
  });
}
//修改优先级、开工、完工
export function updatePlan(data) {
  return request({
    url: "/icps/system/sign/intelligent/planTransport/updatePlan",
    method: "post",
    data,
  });
}
//取消
export function cancelPlan(data) {
  return request({
    url: "/icps/system/sign/intelligent/planTransport/cancelPlan",
    method: "post",
    data,
  });
}
//发料获取相关数据
export function queryOtherData(data) {
  return request({
    url: "/icps/system/sign/intelligent/proLogTask/queryOtherData",
    method: "post",
    data,
  });
}
//根据站点生产线获取车辆信息
export function queryCarData(data) {
  return request({
    url: "/icps/system/sign/intelligent/proLogTask/queryCarData",
    method: "post",
    data,
  });
}
//保存发料
export function sendMaterials(data) {
  return request({
    url: "/icps/system/sign/intelligent/proLogTask/sendMaterials",
    method: "post",
    data,
  });
}
//获取生产任务列表
export function queryStationTaskList(data) {
  return request({
    url: "/icps/system/sign/intelligent/proLogTask/queryStationTaskList",
    method: "post",
    data,
  });
}
//生产任务-作废
export function deleteTask(data) {
  return request({
    url: "/icps/system/sign/intelligent/proLogTask/deleteTask",
    method: "post",
    data,
  });
}
//生产任务- 打票机设置禁用启用
export function updateTicketConfig(data) {
  return request({
    url: "/icps/system/sign/intelligent/proLogTask/updateTicketConfig",
    method: "post",
    data,
  });
}
//生产任务-打票机设置列表
export function queryTicketMachineCon(params) {
  return request({
    url: "/icps/system/sign/intelligent/proLogTask/queryTicketMachineCon",
    method: "GET",
    params,
  });
}
//车辆排队-获取工艺流程生产线分组
export function queryLineGroup(data) {
  return request({
    url: "/icps/system/sign/basics/technological/queryLineGroup",
    method: "post",
    data,
  });
}
//车辆排队-获取车辆列表
export function queryWaitLineUpCars(data) {
  return request({
    url: "/icps/system/sign/basics/car/queryWaitLineUpCars",
    method: "post",
    data,
  });
}
//车辆排队- 添加车辆
export function saveNewTankerUp(data) {
  return request({
    url: "/icps/system/sign/intelligent/tankerQueueUp/saveNewTankerUp",
    method: "post",
    data,
  });
}
//车辆排队- 前移/后移
export function movePosition(data) {
  return request({
    url: "/icps/system/sign/intelligent/tankerQueueUp/movePosition",
    method: "post",
    data,
  });
}
//车辆排队- 删除
export function deleteTanekrUp(data) {
  return request({
    url: "/icps/system/sign/intelligent/tankerQueueUp/deleteTanekrUp",
    method: "post",
    data,
  });
}
//打印
export function saveProDispatch(data) {
  return request({
    url: "/icps/system/sign/intelligent/proLogTask/saveProDispatch",
    method: "post",
    data,
  });
}
//获取运输信息
export function queryProMessionById(data) {
  return request({
    url: "/icps/system/sign/intelligent/logisticsVote/queryProMessionById",
    method: "post",
    data,
  });
}
//获取站上车辆列表
export function queryStationCarNos(data) {
  return request({
    url: "/icps/system/sign/intelligent/logisticsVote/queryStationCarNos",
    method: "post",
    data,
  });
}
//修改物流
export function updateProDispatch(data) {
  return request({
    url: "/icps/system/sign/intelligent/logisticsVote/updateProDispatch",
    method: "post",
    data,
  });
}
//取消物流
export function cancelProDispatch(data) {
  return request({
    url: "/icps/system/sign/intelligent/logisticsVote/cancelProDispatch",
    method: "post",
    data,
  });
}
//签收物流
export function signProDispatch(data) {
  return request({
    url: "/icps/system/sign/intelligent/logisticsVote/signProDispatch",
    method: "post",
    data,
  });
}
//取消签收物流
export function updateProDispatchStatus(data) {
  return request({
    url: "/icps/system/sign/intelligent/logisticsVote/updateProDispatchStatus",
    method: "post",
    data,
  });
}
//物流列表-新
export function queryLogisticsPage(data) {
  return request({
    url: "/icps/system/sign/intelligent/logisticsVote/queryLogisticsPage",
    method: "post",
    data,
  });
}
//物流列表-自动发料
export function queryLogisticsPageByAutoTaskId(data) {
  return request({
    url: "/icps/system/sign/intelligent/logisticsVote/queryLogisticsPageByAutoTaskId",
    method: "post",
    data,
  });
}
//物流列表-自动发料-所有
export function queryAutoTaskLogisticsPage(data) {
  return request({
    url: "/icps/system/sign/intelligent/logisticsVote/queryAutoTaskLogisticsPage",
    method: "post",
    data,
  });
}
//车辆查询
export function queryCarpage(data) {
  return request({
    url: "/icps/system/sign/intelligent/proLogTask/queryCarpage",
    method: "post",
    data,
  });
}
//自动发料特殊产品
export function querySpecailProduct(data) {
  return request({
    url: "/icps/system/sign/intelligent/autoSend/querySpecailProduct",
    method: "post",
    data,
  });
}
//自动发料保存
export function addAutoSendMaterial(data) {
  return request({
    url: "/icps/system/sign/intelligent/autoSend/addAutoSendMaterial",
    method: "post",
    data,
  });
}
//自动发料列表
export function queryTaskList(data) {
  return request({
    url: "/icps/system/sign/intelligent/autoSend/queryTaskList",
    method: "post",
    data,
  });
}
//自动发料 修改
export function updateTask(data) {
  return request({
    url: "/icps/system/sign/intelligent/autoSend/updateTask",
    method: "post",
    data,
  });
}
//自动发料 调整
export function adjustTask(data) {
  return request({
    url: "/icps/system/sign/intelligent/autoSend/adjustTask",
    method: "post",
    data,
  });
}
//发料通知
export function queryNotepage(data) {
  return request({
    url: "/icps/system/sign/intelligent/autoSend/queryNotepage",
    method: "post",
    data,
  });
}
//自动发料 取消限制
export function cancelLimit(data) {
  return request({
    url: "/icps/system/sign/intelligent/autoSend/cancelLimit",
    method: "post",
    data,
  });
}
//生产线维护 修改状态
export function updateLine(data) {
  return request({
    url: "/icps/system/sign/basics/station/updateLine",
    method: "post",
    data,
  });
}
//生产线维护 全部暂停
export function pauseAllTask(data) {
  return request({
    url: "/icps/system/sign/intelligent/autoSend/pauseAllTask",
    method: "post",
    data,
  });
}
//获取工程绑定车辆
export function queryEngeningCars(data) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringExtend/queryEngeningCars",
    method: "post",
    data,
  });
}
// 最大在外车辆设置
export function updatePlanMaxCarNum(data) {
  return request({
    url: "/icps/system/sign/intelligent/planTransport/updatePlanMaxCarNum",
    method: "post",
    data,
  });
}
//获取累计车数、累计方量
export function queryChildSum(data) {
  return request({
    url: "/icps/system/sign/intelligent/proLogTask/queryChildSum",
    method: "post",
    data,
  });
}
//计划明细
export function queryPlans(data) {
  return request({
    url: "/icps/system/sign/intelligent/planTransport/queryPlans",
    method: "post",
    data,
  });
}
